import type { LayoutHandleProps } from 'layouts/Layout/LayoutHandleProps';
import { orgDashboardGradFairsHomeRoute } from 'modules/orgDashboard/routing/orgDashboard.routes';
import type { HorizonAppRouteLoaderArgs } from 'routing/classes/types/AppRouteLoaderArgs';
import type { HorizonAppRouteComponentProps } from 'routing/types/HorizonAppRouteComponentProps';

import { OrgDashboardGradFairsHomeContainerLoadable } from './OrgDashboardGradFairsHomeContainerLoadable';

export const handle = {
  fallbackUrlByLocaleToCurrent: true,
  darkBackground: true,
  showDesktopSearch: true,
} satisfies LayoutHandleProps;

export async function loader(
  _: HorizonAppRouteLoaderArgs<typeof orgDashboardGradFairsHomeRoute>,
) {
  await OrgDashboardGradFairsHomeContainerLoadable.load();
}

export default function OrgDashboardGradFairsHomeHorizonRoute(
  _: HorizonAppRouteComponentProps<typeof loader>,
) {
  return <OrgDashboardGradFairsHomeContainerLoadable />;
}
